import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../../../Store';
import ReactDOM from 'react-dom';
import { isApp, isBrowser, portalUri as staticPortalUri } from '../../../utils';
import PrimaryNavDesktop from '../../wrapper/PrimaryNav/PrimaryNavDesktop';

const HeaderNavDesktop = (props) => {
    const lottery_host = 'https://palottery.pa.gov/';
    const [apiNavigationTop, setApiNavigationTop] = useState({});

    const fetchApiNavigationTop = useCallback(async () => {
        const rawLayoutUri = props.config.config.layout_uri || props.config.config.promotion_uri;
        if (rawLayoutUri && !isApp()) {
            try {
                const layoutUrl = new URL(rawLayoutUri);
                const layoutDomainName = layoutUrl?.hostname;
                let result;
                const fetchUrl = `https://${layoutDomainName}/api/navigation/level/top?screen_type=pc`;
                if (layoutUrl?.username && layoutUrl?.password) {
                    result = await fetch(fetchUrl, {
                        headers: { Authorization: 'Basic ' + btoa(layoutUrl.username + ':' + layoutUrl.password) },
                    });
                } else {
                    result = await fetch(fetchUrl);
                }
                const jsonResult = await result.json();
                setApiNavigationTop(jsonResult);
            } catch (error) {
                console.error(error);
            }
        }
    }, [props.config.config.promotion_uri, setApiNavigationTop]);

    const [viewportWidth, setViewportWidth] = useState(0);

    const handleResize = useCallback(() => {
        if (isBrowser()) {
            setViewportWidth(window.innerWidth);
            fetchApiNavigationTop();
        }
    }, []);

    useEffect(() => {
        // Add the resize event listener only when window is defined
        if (isBrowser()) {
            window.addEventListener('resize', handleResize);

            // Set initial viewport width
            setViewportWidth(window.innerWidth);
            fetchApiNavigationTop();

            // Clean up the event listener on component unmount
            return () => {
                window.removeEventListener('resize', handleResize);
            };
        }
    }, [handleResize]);

    useEffect(() => {
        fetchApiNavigationTop();
    }, [fetchApiNavigationTop]);

    if (isBrowser() && viewportWidth >= 1200) {
        // Only run this code for desktop view to not introduce submenu issues for mobile
        const navWrapper = document.getElementById('nav');
        const rawLayoutUri = props.config.config.layout_uri || props.config.config.promotion_uri;
        let portalUri;
        if (rawLayoutUri) {
            const layoutUrl = new URL(rawLayoutUri);
            const layoutDomainName = layoutUrl?.hostname;
            portalUri = `https://${layoutDomainName}/`;
            
            const logoLinkElement = document.getElementById('pal-logo-link');
     
            if (logoLinkElement) {
                logoLinkElement.href = props.config.config.lottery_host; 
            }
         
          
        }
        return navWrapper
            ? ReactDOM.createPortal(<PrimaryNavDesktop {...{ lottery_host, portalUri: portalUri || staticPortalUri, apiNavigationTop }} />, navWrapper)
            : null;
    } else {
        return null;
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderNavDesktop);
